import {map, switchMap, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {Action} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as OfferActions from './offer.actions';
import {UpdatedOfferAction, UpdateOfferAction} from './offer.actions';
import {OfferService} from '../../service/offer.service';

/**
 * Effects contain the side effects for asynchronous calls so that our components can remain compact
 * We are listening on the Observable of all offer actions until OfferActions.UPDATE_OFFER is dispatched
 * on which we act here to call the OfferService to fetch the new offer from the rest endpoint
 * We will then dispatch our own OfferActions.UPDATED_AMOUNT which will be processed in the reducer
 */
@Injectable()
export class OfferEffects {
  id: number; // used for UpdateOfferAction
  offerService= inject(OfferService);
  actions$= inject(Actions);

  updateOffer$: Observable<Action> = createEffect(
    () => this.actions$.pipe(
      ofType(OfferActions.UPDATE_OFFER))
      .pipe(map((action: UpdateOfferAction) => action))
      .pipe(tap(payload => this.id = payload.id))
      .pipe(switchMap(() =>
        this.offerService
          .getOffer(this.id)
          .pipe(map(data => new UpdatedOfferAction(data)))
      ))
  );

}
